<template>
  <div style="padding-left:5px;padding-right:5px;">
    <div class="pa-5">
      <v-row style="margin-top: 10px">
        <v-col>
          <v-card height="400px">
            <v-sheet elevation="0" width="200px" height="125px" color="green" dark style="position: relative; top: -20px; left: 20px; padding: 5px;">
              <div><b>Staged Updates</b></div>
              <div style="width:100%; text-align: center; font-size: 40px; margin-top: 20px">{{stagedOasisUpdateCount}}</div>
              <div style="width:100%; text-align: center; font-size: 10px"><i>ready to download</i></div>
            </v-sheet>
            <div style="width: 100%; text-align: center;">
              <column-chart :data="stagedOasisUpdateData" style="width: 100%; height: 200px;"></column-chart>
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card height="400px">
            <v-sheet elevation="0" width="250px" height="125px" color="cyan" dark style="position: relative; top: -20px; left: 20px; padding: 5px;">
              <div><b>Installed Versions</b></div>
              <div style="width:100%; text-align: center; font-size: 40px; margin-top: 20px">{{oasisAtLatestSoftwareVersion}}</div>
              <div style="width:100%; text-align: center; font-size: 10px;"><i>latest/total</i></div>
            </v-sheet>
            <div style="width: 100%; text-align: center;">
              <column-chart :library="chartOptions" :data="installedOasisVersionsData" style="width: 100%; height: 200px;"></column-chart>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import semver from 'semver';

export default {
  components: {
  },

  computed: {
    chartOptions() {
      return {
        vAxis: {
          scaleType: 'log',
        },
      };
    },

    stagedOasisUpdateCount() {
      return this.$store.state.stagedOasisUpdateTotals.total;
    },

    stagedOasisUpdateData() {
      const result = [];

      if (this.$store.state.stagedOasisUpdateTotals) {
        Object.keys(this.$store.state.stagedOasisUpdateTotals.versions).forEach((version) => {
          result.push([version, this.$store.state.stagedOasisUpdateTotals.versions[version]]);
        });
      }

      return result;
    },

    oasisAtLatestSoftwareVersion() {
      const { latestOasisSoftwareVersion } = this.$store.state;
      let totalOasis = 0;
      let oasisAtLatest = 0;

      this.$store.state.oasisSoftwareVersions.forEach((cur) => {
        if (cur.version === latestOasisSoftwareVersion.semantic) {
          oasisAtLatest = cur.total;
        }

        totalOasis += cur.total;
      });

      return `${oasisAtLatest}/${totalOasis}`;
    },

    installedOasisVersionsData() {
      const result = [];

      this.$store.state.oasisSoftwareVersions.forEach((cur) => {
        if (cur.total > 1) {
          result.push([cur.version, cur.total]);
        }
      });

      result.sort((a, b) => {
        if (semver.lt(a[0], b[0])) {
          return -1;
        }

        if (semver.gt(a[0], b[0])) {
          return 1;
        }

        return 0;
      });

      return result;
    },
  },
};
</script>
